import { type PropsWithChildren } from 'react';
import { Text } from '@pairy/pds-react';

const LabelText = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Text as="p" color="zinc_400" variant="sm-regular" marginBottom={8}>
      {children}
    </Text>
  );
};

export default LabelText;
